import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

const UI_RADIO_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioGroupComponent),
  multi: true
};

@Component({
  selector: 'radio-group',
  template: `<label class="radio_item" *ngFor="let option of options; index as i">
  <radio [(ngModel)]="radio_option" [value]="option" [name]="name" [disabled]="disabled"></radio>
  <span class="radio_item__desc">{{option}}</span>
</label>
`,
  styles: [`.radio_item{display:flex;align-items:center;position:relative;cursor:pointer;font-size:14px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.radio_item:not(:last-child){margin-bottom:10px}.radio_item .radio_item__desc{position:relative;font-size:14px;margin-left:10px}`],
  providers: [UI_RADIO_CONTROL_VALUE_ACCESSOR]
})
export class RadioGroupComponent implements ControlValueAccessor {

  @Input('options') options: Array<string>;
  @Input('name') name: string = 'lkeradio';
  @Input('disabled') disabled: boolean = false;

  private _radio_option: string;

  constructor() {}

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  set radio_option(opt: string) {
    if(opt && opt !== '') {
      this._radio_option = opt;
    }
    this.onChangeCallback(opt);
  }

  get radio_option() {
    return this._radio_option;
  }

  writeValue(obj: any): void {
    if (obj && obj !== '') {
      this.radio_option = obj;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
